// tslint:disable:max-line-length
import * as jstz from "jstz";
import { isEmpty } from "lodash";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import {
    IUnityProxyFetchTailResponse,
    IUnityProxyFetchHistoricalResponse,
    IUnityProxyQueryResponse,
    QUERY_STYLES,
    IUnityProxyLogsQueryRequest,
    QUERY_REQUEST_ORDER
} from "@tci/common";
import { NgUAPService } from "../../../ng-shared/ng-services/ng-uap.service";

@Injectable()
export class BaseAppDetailLogsService {
    private currentHistoricalQueryId: string;
    private currentHistoricalQueryIdForDownload: string;

    constructor(
        private uapService: NgUAPService
    ) {}

    public createQuery(input: IUnityProxyLogsQueryRequest): Observable<IUnityProxyQueryResponse> {
        if (input.style === QUERY_STYLES.history) {
            this.deleteCurrentHistoricalLogsQuery();
        }

        if (isEmpty(input.logLevels)) {
            delete input.logLevels;
        }

        input.clientTimeZone = jstz.determine().name();

        return this
            .uapService
            .createLogsQuery(input)
            .map((res: IUnityProxyQueryResponse) => {
                if (input.style === QUERY_STYLES.history) {
                    this.currentHistoricalQueryId = res.content.queryId;
                }
                return res;
            });
    }

    public createQueryForDownload(input: IUnityProxyLogsQueryRequest): Observable<IUnityProxyQueryResponse> {
        input.clientTimeZone = jstz.determine().name();
        input.logOrder = QUERY_REQUEST_ORDER.ASC;

        if (isEmpty(input.logLevels)) {
            delete input.logLevels;
        }

        return this
            .uapService
            .createLogsQuery(input)
            .map((res: IUnityProxyQueryResponse) => {
                if (input.style === QUERY_STYLES.history) {
                    this.currentHistoricalQueryIdForDownload = res.content.queryId;
                }
                return res;
            });
    }

    public deleteCurrentHistoricalLogsQuery() {
        if (this.currentHistoricalQueryId && 1 !== 1) {
            this
                .uapService
                .deleteLogsQuery(this.currentHistoricalQueryId)
                .subscribe(
                    () => {
                        console.log("Successfully deleted query: ", this.currentHistoricalQueryId);
                        this.currentHistoricalQueryId = undefined;
                    },
                    error => {
                        console.log("Error deleting query: ", this.currentHistoricalQueryId, error);
                    }
                );
        }
    }

    public fetchLogs(input: any): Observable<IUnityProxyFetchTailResponse | IUnityProxyFetchHistoricalResponse> {
        return this
            .uapService
            .getLogsResult(input);
    }

    public fetchLogsForDownload(input: any): Observable<IUnityProxyFetchTailResponse | IUnityProxyFetchHistoricalResponse> {
        return this
            .uapService
            .getLogsResult(input);
    }

    public removeExtraLogLevelMessages(logEntries: string[]): string[] {
        const rLogLevel = /\[level:([A-Z]+)\]\s*/;
        const aMatches = logEntries[4].match(rLogLevel);

        if (aMatches && aMatches.length > 1) {
            return logEntries
                .slice(0, 3)
                .concat(aMatches[1])
                .concat(logEntries[4].replace(rLogLevel, ""));
        } else {
            return logEntries;
        }
    }

    private getRandom() {
        return Math.random();
    }
}
